import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useRouter } from '@bibliocommons/utils-routing';

import Checkbox from 'app/components/shared/Checkbox';

export default function OpenNowFilter({ id, ...props }) {
  const router = useRouter();

  function handleChange(openNow) {
    router.push({
      query: {
        ...router.query,
        open: openNow
      }
    });
  }

  return (
    <Checkbox
      id={id}
      className="cp-open-now-filter"
      dataKey="open-now-filter"
      label={<FormattedMessage id="open_now" />}
      checked={router.query.open === 'true'}
      handleChange={handleChange}
      {...props}
    />
  );
}

OpenNowFilter.propTypes = {
  id: PropTypes.string.isRequired
};
